import * as types from '../../actionTypes';

const initialState = {
    setPartners: [],
    error: {},
    loading: false,
}



export  const setPartnerReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_PARTNER_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.SET_PARTNER_SUCCESS:
            console.log("actionddddd",action.payload)
            return {
                ...state,
                setPartners: action.payload,
                loading: false,
                error: {}
            }
        case types.SET_PARTNER_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
                setPartners: []
            }
        
        default:
            return state;
    }
}